import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://ujmqlwixgwqfqyucozrf.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVqbXFsd2l4Z3dxZnF5dWNvenJmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM1NzQxMzksImV4cCI6MjA4OTE1MDEzOX0.c4Ex81FhnXGYjAOpo85KL9oT4UYI_ibzYglrPqXcVS8'

export const supabase = createClient(supabaseUrl, supabaseKey)